import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import { useNavigate, useParams } from "react-router-dom";
import { getAllAttendeeListApi } from "../../../services/apis/EventMangement/AttendeesList";
// import NoImageProfile from "../../../assets/images/avatar/1.png"
import NoImageProfile from "../../../assets/images/avatar/default-avatar.jpg"
import ReactPaginate from "react-paginate";
import * as XLSX from 'xlsx';
import { FaFileDownload } from "react-icons/fa";

const theadData = [
    { heading: "S.No", sortingVale: "sno" },
    { heading: "Logo", sortingVale: "logo" },
    { heading: "Name", sortingVale: "name" },
    { heading: "Phone", sortingVale: "phone" },
    { heading: "Email", sortingVale: "email" },
    { heading: "Organization", sortingVale: "organization" },
    { heading: "City", sortingVale: "city" },
    { heading: "Code", sortingVale: "code" },
    // { heading: "Status", sortingVale: "status" },
    // { heading: "Mode", sortingVale: "mode" },
    // { heading: "Action", sortingVale: "action" },
];

const AttendeeDetails = () => {
    const navigate = useNavigate();
    const parmas = useParams()?.id;

    const [sort, setSortata] = useState(10);
    const [loading, setLoading] = useState(false);

    const [allEventList, setAllEventList] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchBtnValue, setSearchBtnValue] = useState('')

    const [showDeleteMdl, setShowDeleteMdl] = useState(false);
    const [deleteTableDataId, setDeleteTableDataId] = useState("");


    const getAllEventList = async () => {

        setLoading(true);
        try {
            const response = await getAllAttendeeListApi(parmas, sort, currentPage, searchBtnValue);

            if (response?.data?.success) {
                setAllEventList(response?.data)
            }

        } catch (error) {
            console.error("Error fetching cuisines:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllEventList();
    }, [parmas, sort, currentPage, searchBtnValue]);



    const handleDeleteSubmit = async () => {
        try {
            // const res = await deleteEvent(deleteTableDataId);
            const res = ''
            if (res.status == 200) {
                toast.success(res?.data?.message); // Display success message
                getAllEventList();
                setDeleteTableDataId("");
                setShowDeleteMdl(false);
            } else {
                toast.error(
                    res?.data?.message || "Something went wrong. Please try again."
                );
            }
        } catch (err) {
            console.log(err);
        }
    };


    const handleEdit = (id) => {
        navigate(`/edit-my-event/${id}`);
    };

    const handleDelete = (id) => {
        setDeleteTableDataId(id);
        setShowDeleteMdl(true);
    };

    const handlePageClick = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    const handleQuery = (e) => {
        setSearchQuery(e.target.value)
    }




    const exportToExcel = () => {
        const filteredData = allEventList?.data;

        if (!filteredData || filteredData.length === 0) {
            alert("No valid data to export.");
            return;
        }

        // Create table headers dynamically, matching the structure of your table
        const headers = [
            "S.No.",
            "Profile Image",
            "Customer Name",
            "Phone",
            "Email",
            "Organisation",
            "City",
            "QR Code"
        ];

        // Generate table rows, excluding the image column, and map to text-based format
        const rows = filteredData.map((data, ind) => [
            ind + 1,
            data?.customer_picture ? `https://eventbackend.idea2reality.tech/public/image/${data?.customer_picture}` : "No Image",
            data?.customer_name,
            `+${data?.customer_phone}`,
            data?.customer_email,
            data?.customer_organisation,
            data?.customer_city,
            data?.customer_qr_code
        ]);

        // Add the headers and rows to an Excel workbook
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EventData");

        // Write the file to the user
        XLSX.writeFile(workbook, "BookingList.xlsx");
    };

    return (
        <>
            <DeleteWarningMdl title={"table data"} showDeleteMdl={showDeleteMdl} setShowDeleteMdl={setShowDeleteMdl}
                setDeleteTableDataId={setDeleteTableDataId} handleDeleteSubmit={handleDeleteSubmit} />

            <ToastContainer />

            <Loader visible={loading} />

            <PageTitle
                activeMenu={"All Attendees"}
                motherMenu={"All Events"}
                motherMenuLink={"/all-events"}
            />

            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-header">

                            <h4 className="card-title">Total Bookings ({allEventList?.totalBookings})</h4>
                            <div className="Export-button-multi">
                                <button onClick={exportToExcel} className="px-3" title='Download Excel'><FaFileDownload size={18}/> Export</button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div id="holidayList" className="dataTables_wrapper no-footer">
                                    <div className="justify-content-between d-sm-flex">
                                        <div className="dataTables_length">
                                            <label className="d-flex align-items-center">
                                                Show
                                                <Dropdown className="search-drop">
                                                    <Dropdown.Toggle as="div" className="search-drop-btn">
                                                        {sort}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => setSortata("2")}>
                                                            2
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("5")}>
                                                            5
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("10")}>
                                                            10
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("15")}>
                                                            15
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("20")}>
                                                            20
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("50")}>
                                                            50
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                entries
                                            </label>
                                        </div>

                                        <div className='d-flex gap-2'>
                                            <input type='search'
                                                className='form-control'
                                                onChange={handleQuery}
                                                placeholder='Serach Attendee'
                                            />
                                            <div>
                                                <button className="btn"
                                                    onClick={() => setSearchBtnValue(searchQuery)}
                                                    style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }}
                                                >Search</button>
                                            </div>
                                        </div>
                                    </div>


                                    <table id="example4" className="display dataTable no-footer w-100">
                                        <thead>
                                            <tr>
                                                {theadData?.map((item, ind) => {
                                                    return (
                                                        <th key={ind}>
                                                            {item.heading}
                                                            <span>
                                                                <i
                                                                    className="fa fa-arrow-down ms-2 fs-12"
                                                                    style={{ opacity: "0.7" }}
                                                                />

                                                            </span>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allEventList?.data?.map((data, ind) => (
                                                <tr key={ind}>
                                                    <td>
                                                        {ind + 1}
                                                    </td>

                                                    <td className="d-flex align-items-center gap-2">
                                                        <img src={data?.customer_picture == "" ?
                                                            NoImageProfile :
                                                            `https://eventbackend.idea2reality.tech/public/image/${data?.customer_picture}`}
                                                            alt="No Image"
                                                            style={{ height: '50px', width: '50px', objectFit: 'cover', borderRadius: '50%' }}
                                                        />
                                                    </td>

                                                    <td>
                                                        {data?.customer_name}
                                                    </td>

                                                    <td>
                                                        +{data?.customer_phone}
                                                    </td>

                                                    <td>
                                                        {data?.customer_email}
                                                    </td>

                                                    <td>
                                                        {data?.customer_organisation}
                                                    </td>

                                                    <td>
                                                        {data?.customer_city}
                                                    </td>

                                                    <td>
                                                        {data?.customer_qr_code}
                                                    </td>

                                                    {/* <td>
                                                    </td> */}

                                                    {/* <td>
                                                        <button className="btn btn-xs sharp btn-primary me-1"
                                                            onClick={() => handleEdit(data?._id)}
                                                        >
                                                            <i className="fa fa-pencil" />
                                                        </button>

                                                        <button className="btn btn-xs sharp btn-danger"
                                                            onClick={() => handleDelete(data?._id)}
                                                        >
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                    <div>
                                        {/* {brandList?.data?.length < brandList?.total && ( */}
                                        <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                                            <div className="pagination-container">
                                                <ReactPaginate
                                                    pageCount={Math.ceil(
                                                        allEventList?.totalBookings /
                                                        allEventList?.itemsPerPage
                                                    )}
                                                    pageRangeDisplayed={1}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="selected"
                                                    disabledClassName="disabled"
                                                />
                                            </div>
                                        </div>
                                        {/* )} */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default AttendeeDetails;

